import useSWR from 'swr';
import urlResolver from 'admin/utils/URLResolver';
import { fetcher } from './utils';

export const useStudentNotes = (classId: ClassId, profileId: string) => {
  const { data: studentNotesData, error: studentNotesError } = useSWR(
    urlResolver.reverse('api:student-notes', { classId, profileId }),
    fetcher
  );

  const studentNotesIsLoading = !studentNotesError && !studentNotesData;

  return {
    studentNotesData,
    studentNotesError,
    studentNotesIsLoading,
  };
};
